import type { EntityDto } from '@app/api/dtos'

export const getIdsFromEntity = (entity?: EntityDto[] | Array<EntityDto<number>>): Array<string | number> => {
  return entity?.map(item => item.id) ?? []
}
